import { Extension } from "@tiptap/react";
import { NodeSelection, Plugin, TextSelection } from "@tiptap/pm/state";

// Quality-of-life keymap on top of the stock extensions.
export const EditorKeymap = Extension.create({
  name: "documentKeymap",

  addKeyboardShortcuts() {
    return {
      // Code is unwritable without Tab. Lists and tables bind their own Tab
      // and this handler yields to them by only claiming code blocks.
      Tab: ({ editor }) => {
        if (!editor.isActive("codeBlock")) return false;
        return editor.commands.insertContent("  ");
      },
      // Notion muscle memory: Mod+Enter toggles the to-do under the caret.
      "Mod-Enter": ({ editor }) => {
        if (!editor.isActive("taskItem")) return false;
        const checked = editor.getAttributes("taskItem").checked === true;
        return editor.commands.updateAttributes("taskItem", { checked: !checked });
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          // Escape on a selected block (image, divider, table) deselects it.
          // This lives in handleDOMEvents (not addKeyboardShortcuts) because a
          // consumed Escape must also stopPropagation — the surrounding dialog
          // listens on the document and would close; ProseMirror keymaps only
          // get to preventDefault.
          handleDOMEvents: {
            keydown: (view, event) => {
              if (event.key !== "Escape") return false;
              const { selection } = view.state;
              if (!(selection instanceof NodeSelection)) return false;
              event.preventDefault();
              event.stopPropagation();
              const $inside = view.state.doc.resolve(Math.min(selection.from + 1, view.state.doc.content.size));
              view.dispatch(view.state.tr.setSelection(TextSelection.near($inside)));
              return true;
            },
          },
        },
      }),
    ];
  },
});
